import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import ScrollLTR from "../lms-shared/UI/ScrollLTR";
import classes from "./TabsMenu.module.css";

const TabsMenu = forwardRef(({ dropClass, menuDropClass, dropClassSelectedTab, scrollContentHeight, startTabIndex, children, contentHeight, onDisabledClick, onTabClick }, ref) => {

    const [currentTab, setCurrentTab] = useState();

    useEffect(() => {
        if (startTabIndex)
            setCurrentTab(startTabIndex)
        else
            setCurrentTab(0)
    }, [startTabIndex])

    useImperativeHandle(ref, () => ({
        setCurrentTab,
    }))
    
    const handleTabClick = (index) => {
        if (children[index].props.disabeled) {
            onDisabledClick && onDisabledClick();
        } else {
            setCurrentTab(index);
            onTabClick && onTabClick(index);
        }
    };

    return <div className={`${classes.TabsMenu} ${dropClass}`}>
        <div className={`${classes.Menu} ${menuDropClass}`}>
            {children && children.map((t, i) => <div
               onClick={() => handleTabClick(i)}
                className={`${classes.Tab} ${t.props.disabeled && classes.Disable} ${currentTab === i ? dropClassSelectedTab ? dropClassSelectedTab : classes.SelectTab : ''}`}
                key={t.props.name}
            >
                {t.props.name}</div>)}
        </div>
        <ScrollLTR dropStyle={{ height: contentHeight }} downDropStyle={{ height: scrollContentHeight }}>
            {children[currentTab]?.props.children}
        </ScrollLTR>
    </div>
})

const Tab = ({ name, disabeled }) => {

}
export { TabsMenu, Tab };